<div class="focus-dialog-container" *ngIf="ngShowFocusDialog">
    <div class="focus-dialog-top-container">
        <!-- The same generic dialog is fired up in two scenarios, when students take long time to finish a task and when they
        select the same answer in all trials.
        This message could probably be customized based on the scenario by accepting it as an argument. -->
        <div class="focus-dialog-subtext-container">
          <label class="focus-dialog-subtext font-42">
            <img src="/assets/images/warning.svg" class="focus-dialog-icon">
            <span>Please focus. Try your best.</span>
          </label>
        </div>
    </div>
    <div class="focus-dialog-bottom-container">
        <button class="focus-dialog-btn" (click)="focusDialogPositive()">
            <span class='focus-text font-30'>OK</span>
        </button>
    </div>
</div>
